// extracted by mini-css-extract-plugin
export default {"copiedMessageWrapper":"CopiedToClipboard_copiedMessageWrapper__gD97-"};